import Vue from "vue";
import ResizeTable from "../resizeTable.js"
import { mapGetters, mapActions, mapState } from "vuex";
import JsonViewerDialog from "../../components/JsonViewerDialog";
import Loader from "@/components/Loader";
import { convertIntlDateFormat } from "@/utils/util";
import ADataTable from '@/wrapper-component/ADataTable.vue';
import SearchInput from "@/components/SearchInput.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
export default {
  name: "Activities",
  components: { JsonViewerDialog, Loader, ADataTable, SearchInput, ABtn, ConfirmDialog },
  data() {
    return {
      resetDates: 0,
      validDate: true,
      fromRule: [
        v => !!v || this.$t("agenda.fromDateRequired"),
      ],
      toRule: [
        v => !!v || this.$t("agenda.toDateRequired"),
      ],
      logLimit: 100,
      Loaderloading: false,
      jsonData: {},
      jsonViewerHeader: "",
      activityLogInfoDialog: false,
      dataloading: false,
      page: 1,
      pageCount: 0,
      search: "",
      calmenu: false,
      calmenu2: false,
      requiredRules: [(v) => this.valid || "Enter valid due date."],
      currentDate: new Date().toISOString().slice(0, 10),
      fromdate: "",
      todate: "",
      screenHeight: 0,
    }
  },
  mounted() {
    var wrapper = document.getElementsByClassName('v-data-table__wrapper');
    //ResizeTable.resizableGrid(wrapper[0]);
  },
  async created() {
    this.resetActivityLogs()
    await this.getActivityLogs()
  },
  watch: {
    fromdate(date) {
      if (date > this.todate && this.to_date != '') {
        this.todate = '';
      }
    },
    search() {
      // this.filterActivities()
    },
  },
  computed: {
    ...mapState({
      activityLogsState: (state) => state.admin.activitylogs,
      totalCount: (state) => state.admin.totalCount,
    }),
    ...gettersMap(),
    selectedLang() {
      return this.$i18n.locale;
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    isReset() {
      return (this.search && this.search != '') || (this.fromdate && this.fromdate != '') || (this.todate && this.todate != '')
    },
    activityLogs() {
      if(!this.activityLogsState){
        return [];
      }
      return this.activityLogsState.map(activity => ({
          ...activity,
          category: this.getCategory(activity.category),
          activity_category: activity.category,
          activity_status: activity.status,
          status: activity.status.toLowerCase() === "success"
          ? this.$t("activity.lblSuccess")
          : this.$t("activity.lblFailed")
      }));
    },
    formatFromDate() {
      if (!this.fromdate) return null

      const [year, month, day] = this.fromdate.split('-')
      return `${day}-${month}-${year}`
    },
    formatToDate() {
      if (!this.todate) return null

      const [year, month, day] = this.todate.split('-')
      return `${day}-${month}-${year}`
    },
    headingColumns() {
      return [
        {
          label: this.$t("activity.time"),
          field: "time",
        },
        {
          label: this.$t("activity.category"),
          field: "category",
        },
        {
          label: this.$t('activity.activity'),
          field: "activity",
        },
        {
          label: this.$t('activity.status'),
          field: "status",
        },
        {
          label: this.$t('activity.userEmail'),
          field: "user",
        },
        {
          label: this.$t('activity.platform'),
          field: "platform",
        },
        {
          label: this.$t("activity.activityDetails"),
          field: "activityDetails",
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t('activity.time'),
          align: "left",
          value: "time",
          class: "header header-text",
          dataType: "Date",
          width: "220px",
          filterable: false,
        },

        {
          text: this.$t('activity.category'),
          align: "left",
          value: "category",
          class: "header header-text",
          width: "10%",
          filterable: true,
        },
        {
          text: this.$t('activity.activity'),
          align: "left",
          value: "activity",
          class: "header header-text",
          width: "45%",
          filterable: true,
        },
        {
          text: this.$t('activity.status'),
          align: "left",
          value: "status",
          class: "header header-text",
          filterable: true,
        },
        {
          text: this.$t('activity.userEmail'),
          align: "left",
          value: "user",
          class: "header header-text",
          filterable: true,
        },
        {
          text: this.$t('activity.platform'),
          align: "left",
          value: "platform",
          class: "header header-text",
          filterable: false,
          width: "10%",
          sortable: false
        },
      ]
    },
    getExportData() {
      const searchText = this.search ? this.search.toLowerCase() : '';
    
      const filteredLogs = this.activityLogs.filter((item) => {
        if (!searchText) return true;
    
        // Combine searchable fields into a string for matching
        const combinedFields = [
          item.time,
          item.category,
          item.status,
          item.user_email,
          item.activity
        ]
          .map(val => String(val).toLowerCase())
          .join(' ');
    
        return combinedFields.includes(searchText);
      });
    
      // Map the filtered data to the export structure
      const logs = filteredLogs.map((item) => {
        return {
          ...item,
          time: this.convertIntlDateFormat(item.time),
          category: this.getCategory(item.category),
          status: item.status.toLowerCase() === 'success'
            ? this.$t('activity.lblSuccess')
            : this.$t('activity.lblFailed'),
          user: item.user_email,
          activity: item.activity,
          activityDetails: JSON.stringify(item)
        };
      });
    
      return logs;
    },
    getExportDataOld(){
      const logs = this.activityLogs.map(
        (item) => {
          return {
            ...item,
            time: this.convertIntlDateFormat(item.time),
            category: this.getCategory(item.category),
            status: item.status.toLowerCase() == "success"
            ? this.$t("activity.lblSuccess")
            : this.$t("activity.lblFailed"),
            user: item.user_email,
            activity: item.activity,
            activityDetails: JSON.stringify(item)
          };
        }
      );
      return logs;
    }
  },
  methods: {
    ...mapActions({
      getActivityListApi: "admin/getActivityList",
      setActivityFilterApi: "admin/setActivityFilter",
      resetActivityLogs: "admin/resetActivityLogs",
    }),
    onResize() {
      this.screenHeight = window.innerHeight - 290;
    },
    getCategory(category) {
      switch (category) {
        case 'Agenda':
          return this.$t('menu.agenda');
        case 'Meeting':
          return this.$t('Meeting');
        case 'Document':
          return this.$t('activity.document');
        case 'Admin':
          return this.$t('menu.admin');
        case 'Email Notification':
          return this.$t('activity.emailNotification');
        case 'Survey':
          return this.$t('activity.survey');
        case 'People':
          return this.$t('menu.people');
        case 'Settings':
          return this.$t('menu.settings');
        case 'Search':
          return this.$t('menu.search');
        case 'News':
          return this.$t('home.lblAnnouncement');
        default:
          return category;
      }
    },
    convertIntlDateFormat,
    async filterActivities() {
      try {
        if (this.$refs.refdaterange.validate()) {
          this.resetActivityLogs()
          this.Loaderloading = true;

          let toISODate = new Date(this.todate).toISOString();
          let beforeToDate = new Date(this.todate);
          beforeToDate.setUTCHours(23, 59, 59, 999);
          toISODate = beforeToDate.toISOString();

          const query = {
            is_user_activity: 'True',
            offset: this.activityLogs.length,
            from_date: new Date(this.fromdate).toISOString(),
            to_date: toISODate,
            limit: this.logLimit
          };
          //console.log(query)
          await this.getActivityListApi(query)
          this.Loaderloading = false;
        }
      } catch (error) {
        this.Loaderloading = false;
      }
      // this.setActivityFilterApi({ keyword: this.search, fromdate: this.fromdate, todate: this.todate });
    },
    async resetForm() {
      try {
        this.resetDates++;
        this.search = ''
        this.fromdate = ''
        this.todate = ''
        this.$refs.refdaterange.resetValidation();
        // this.filterActivities()
        this.resetActivityLogs();
        await this.getActivityLogs()
      } catch (error) {
        this.Loaderloading = false;
      }
    },
    getColor(category) {
      switch (category) {
        case 'Agenda':
          return 'teal lighten-2';
        case 'Meeting':
          return 'orange lighten-2';
        case 'Document':
          return 'primaryDark lighten-3';
        case 'Admin':
          return 'accent lighten-4';
        case 'Email Notification':
          return 'blue-grey lighten-2';
        case 'Survey':
          return 'pink lighten-2';
        case 'People':
          return 'purple lighten-2';
        case 'Settings':
          return 'secondary darken-3';
        case 'Search':
          return 'blue lighten-2'
        case 'News':
          return 'grey darken-1';
      }
    },
    openActivityLogInfo,
    openErrorInfo,
    onViewMoreClick,
    getActivityLogs,
    async exportArrayToCSV(){
      if (
        await this.$refs.confirm.open(
          this.$t("task.lblConfirmation"),
          this.$t("activity.exportText", {record: this.activityLogs.length, total: this.totalCount})
        )
      ) {
        const csvHeaders = this.headingColumns.map(h => h.label).join(',');
        // Prepare CSV data rows by mapping header fields to item values
        const csvRows = this.getExportData.map(item =>
          this.headingColumns.map(h => {
            let value = item[h.field] !== undefined ? item[h.field] : '';
            if (typeof value === 'string') {
              value = value.replace(/"/g, '""'); // Escape double quotes
              if (value.search(/("|,|\n)/g) >= 0) {
                value = `"${value}"`; // Wrap if necessary
              }
            }
            return value;
          }).join(',')
        );

        // Combine header and data rows
        const csvContent = [csvHeaders, ...csvRows].join('\n');

        // Create and download CSV file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', 'activity-log.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  },
}

async function onViewMoreClick() {
  await this.getActivityLogs()
}

async function getActivityLogs() {
  try {
    this.Loaderloading = true;
    let query = {
      is_user_activity: 'True',
      offset: this.activityLogs.length,
      limit: this.logLimit
    };
    if (this.fromdate && this.todate) {
      let toISODate = new Date(this.todate).toISOString();
      let beforeToDate = new Date(this.todate);
      beforeToDate.setUTCHours(23, 59, 59, 999);
      toISODate = beforeToDate.toISOString();
      query = {
        is_user_activity: 'True',
        offset: this.activityLogs.length,
        from_date: new Date(this.fromdate).toISOString(),
        to_date: toISODate,
        limit: this.logLimit
      };
    }
    await this.getActivityListApi(query)
    this.Loaderloading = false;
  } catch (error) {
    this.Loaderloading = false;
  }
}

function openActivityLogInfo(jsonData) {
  this.jsonData = jsonData
  this.jsonViewerHeader = this.$t("activity.activityDetails")
  this.activityLogInfoDialog = true
}

function openErrorInfo(jsonData) {

  const { error_message, time, status, status_code } = { ...jsonData }
  this.jsonData = {
    error_message, status, status_code, time
  }
  this.jsonViewerHeader = this.$t("activity.errorDetails")
  this.activityLogInfoDialog = true
}

function gettersMap() {
  return mapGetters({
    activityList: "admin/activityLogs",
  });
}
